<template>
  <div class="relative px-4 pt-4 pb-32 lg:py-4 lg:py-6 lg:flex-1 lg:p-12 lg:overflow-y-auto h-screen flex justify-center items-center">
    <div class="max-w-md mx-auto px-4 text-center card rounded-lg mb-4 lg:mb-8 relative">

      <img src="/img/error/cooler-fuchs.svg" alt="DGVT Elearning" class="mx-auto block my-4 max-w-[180px]">

      <h1 class="text-md lg:text-xl text-secondary-500 group-hover:text-white font-bold mb-3">{{ title }}</h1>
      <div v-html="description"></div>

      <div class="buttons my-5 mx-auto max-w-xs gap-2 grid">
        <Link href="/" class="btn btn-primary block">Startseite</Link>
        <Link href="/login" class="btn btn-primary block">Login</Link>
      </div>
    </div>

  </div>
</template>

<script setup>
import { computed } from 'vue'
import {Link} from '@inertiajs/inertia-vue3'

const props = defineProps({ status: Number })

const title = computed(() => {
  return {
    503: '503: Service nicht verfügbar',
    500: '500: Server Error',
    404: '404: Seite nicht gefunden',
    403: '403: Zugriff verweigert',
  }[props.status]
})

const description = computed(() => {
  return {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: '<p class="mb-2">Es gibt ein unerwartetes Problem mit dem Server - das kann passieren, auch Server sind fehlbar.</p><p>Keep cool.</p><p>Möglicherweise hilft es, wenn du dich ausloggst und wieder einloggst. Wenn es nicht weiterhilft, schreib uns gerne eine E-Mail an <a href="mailto:campus@dgvt.de" class="link">campus@dgvt.de</a>, wir kümmern uns um die Fehlerbehebung.</p><br><p>Dein Fuchs-Team</p>',
    404: '<p class="mb-2">Die von dir angesteuerte Seite ist entweder nicht vorhanden oder wurde verschoben.</p><p>Bitte überprüfe, ob die eingegebene URL korrekt ist, oder versuche es über diese Seiten:</p>',
    403: 'Sorry, you are forbidden from accessing this page.',
  }[props.status]
})
</script>

